import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../Library.mjs';
import {
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
} from '../js/coreRuntime.mjs';
import { AbstractSet2mw1ev10zm1bz as AbstractSet } from './AbstractSet.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../hacks.mjs';
import { AbstractCollection1g9uvtcheckwb as AbstractCollection } from './AbstractCollection.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  Entry2xmjmyutzoq3p as Entry,
  KtMap140uvy3s5zad8 as KtMap,
} from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from './_Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractMap$keys$1$iterator$1Class;
function AbstractMap$keys$1$iterator$1() {
  if (AbstractMap$keys$1$iterator$1Class === VOID) {
    class $ {
      constructor($entryIterator) {
        this.kk_1 = $entryIterator;
      }
      n1() {
        return this.kk_1.n1();
      }
      o1() {
        return this.kk_1.o1().e2();
      }
    }
    initMetadataForClass($);
    AbstractMap$keys$1$iterator$1Class = $;
  }
  return AbstractMap$keys$1$iterator$1Class;
}
var AbstractMap$values$1$iterator$1Class;
function AbstractMap$values$1$iterator$1() {
  if (AbstractMap$values$1$iterator$1Class === VOID) {
    class $ {
      constructor($entryIterator) {
        this.lk_1 = $entryIterator;
      }
      n1() {
        return this.lk_1.n1();
      }
      o1() {
        return this.lk_1.o1().f2();
      }
    }
    initMetadataForClass($);
    AbstractMap$values$1$iterator$1Class = $;
  }
  return AbstractMap$values$1$iterator$1Class;
}
function toString_0($this, entry) {
  return toString_1($this, entry.e2()) + '=' + toString_1($this, entry.f2());
}
function toString_1($this, o) {
  return o === $this ? '(this Map)' : toString(o);
}
function implFindEntry($this, key) {
  var tmp0 = $this.d2();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (equals(element.e2(), key)) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var AbstractMap$keys$1Class;
function AbstractMap$keys$1() {
  if (AbstractMap$keys$1Class === VOID) {
    class $ extends AbstractSet() {
      static nk(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.mk_1 = this$0;
        return this.ok($box);
      }
      e9(element) {
        return this.mk_1.n3(element);
      }
      t1(element) {
        if (!(element == null ? true : !(element == null)))
          return false;
        return this.e9((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      m1() {
        var entryIterator = this.mk_1.d2().m1();
        return new (AbstractMap$keys$1$iterator$1())(entryIterator);
      }
      p1() {
        return this.mk_1.p1();
      }
    }
    initMetadataForClass($);
    AbstractMap$keys$1Class = $;
  }
  return AbstractMap$keys$1Class;
}
var AbstractMap$values$1Class;
function AbstractMap$values$1() {
  if (AbstractMap$values$1Class === VOID) {
    class $ extends AbstractCollection() {
      static qk(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.pk_1 = this$0;
        return this.j6($box);
      }
      o9(element) {
        return this.pk_1.o3(element);
      }
      t1(element) {
        if (!(element == null ? true : !(element == null)))
          return false;
        return this.o9((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      m1() {
        var entryIterator = this.pk_1.d2().m1();
        return new (AbstractMap$values$1$iterator$1())(entryIterator);
      }
      p1() {
        return this.pk_1.p1();
      }
    }
    initMetadataForClass($);
    AbstractMap$values$1Class = $;
  }
  return AbstractMap$values$1Class;
}
var AbstractMapClass;
function AbstractMap() {
  if (AbstractMapClass === VOID) {
    class $ {
      static q7() {
        var $this = createThis(this);
        $this.o7_1 = null;
        $this.p7_1 = null;
        return $this;
      }
      n3(key) {
        return !(implFindEntry(this, key) == null);
      }
      o3(value) {
        var tmp0 = this.d2();
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.i1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (equals(element.f2(), value)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        return tmp$ret$0;
      }
      x7(entry) {
        if (!(!(entry == null) ? isInterface(entry, Entry()) : false))
          return false;
        var key = entry.e2();
        var value = entry.f2();
        // Inline function 'kotlin.collections.get' call
        var ourValue = (isInterface(this, KtMap()) ? this : THROW_CCE()).p3(key);
        if (!equals(value, ourValue)) {
          return false;
        }
        var tmp;
        if (ourValue == null) {
          // Inline function 'kotlin.collections.containsKey' call
          tmp = !(isInterface(this, KtMap()) ? this : THROW_CCE()).n3(key);
        } else {
          tmp = false;
        }
        if (tmp) {
          return false;
        }
        return true;
      }
      equals(other) {
        if (other === this)
          return true;
        if (!(!(other == null) ? isInterface(other, KtMap()) : false))
          return false;
        if (!(this.p1() === other.p1()))
          return false;
        var tmp0 = other.d2();
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.i1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (!this.x7(element)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      p3(key) {
        var tmp0_safe_receiver = implFindEntry(this, key);
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f2();
      }
      hashCode() {
        return hashCode(this.d2());
      }
      i1() {
        return this.p1() === 0;
      }
      p1() {
        return this.d2().p1();
      }
      q3() {
        if (this.o7_1 == null) {
          var tmp = this;
          tmp.o7_1 = AbstractMap$keys$1().nk(this);
        }
        return ensureNotNull(this.o7_1);
      }
      toString() {
        var tmp = this.d2();
        return joinToString(tmp, ', ', '{', '}', VOID, VOID, (it) => toString_0(this, it));
      }
      r3() {
        if (this.p7_1 == null) {
          var tmp = this;
          tmp.p7_1 = AbstractMap$values$1().qk(this);
        }
        return ensureNotNull(this.p7_1);
      }
    }
    initMetadataForClass($, 'AbstractMap', VOID, VOID, [KtMap()]);
    AbstractMapClass = $;
  }
  return AbstractMapClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  AbstractMap as AbstractMap3sqd8xvg0030s,
};
//endregion

//# sourceMappingURL=AbstractMap.mjs.map
